module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-cell-group"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e5fa093!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/cell/src/cell-group.vue
// module id = 137
// module chunks = 2 3